module.exports = __webpack_public_path__ + "static/media/Rational_Poojas_m_mr.13d3eae1.jpg";